import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const matSeccionesApi = `${baseUrl}/matricula-secciones`;

export const allMatSeccionesService = async (params) => {
  const res = await axios.get(matSeccionesApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveMatSeccionesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${matSeccionesApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(matSeccionesApi, data, { headers: token({}) });
  }
  return res;
};

export const deleteMatSeccionesService = async (id) => {
  const res = await axios.delete(`${matSeccionesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
